// Libraries
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
// Shared Modules
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Shared Services
import { ApiService, LocalStorageService, SessionStorageService,
    SettingService, FileService, CatalogService, StudentService, MenuService, LocalNetworkService } from './services';
// Components
import { FooterComponent } from './components/footer/FooterComponent';
import { MainMenuComponent } from './components/main-menu/MainMenuComponent';
import { TopMenuComponent } from './components/top-menu/TopMenuComponent';
import { MenuHoverDirective } from './directives/MenuHoverDirective';
import { AdminHeaderComponent } from './components/admin-header/AdminHeaderComponent';
import { AdminHeaderAuthComponent } from './components/admin-header-auth/AdminHeaderAuthComponent';
import { AdminSidebarComponent } from './components/admin-sidebar/AdminSidebarComponent';
// Services
import { AdminService } from '../admin/services/AdminService';
import { SessionService } from '../admin/services';
import { HolidayService } from '../../../holiday/services/HolidayService';
// import { HolidayService } from '../../../holiday/services/HolidayService';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideDirective } from './directives/ClickOutsideDirective';
import { DialogModule, GrowlModule } from 'primeng/primeng';
import { FormsModule } from '@angular/forms';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        TranslateModule,
        DialogModule,
        GrowlModule
    ],
    declarations: [
        FooterComponent,
        MainMenuComponent,
        TopMenuComponent,
        MenuHoverDirective,
        ClickOutsideDirective,
        AdminHeaderComponent,
        AdminHeaderAuthComponent,
        AdminSidebarComponent
    ],
    providers: [
        // Services
        SettingService,
        ApiService,
        LocalStorageService,
        SessionStorageService,
        FileService,
        CatalogService,
        StudentService,
        MenuService,
        AdminService,
        LocalNetworkService,
        SessionService,
        HolidayService
    ],
    exports: [
        FooterComponent,
        MainMenuComponent,
        TopMenuComponent,
        MenuHoverDirective,
        AdminHeaderComponent,
        AdminHeaderAuthComponent,
        AdminSidebarComponent
    ]
})
/**
 * The CoreModule which will define the modules, components & directives that will
 * be called only onetime in the main AppModule when the app loads. Do not import 
 * the CoreModule more than one time.
 */
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        // Guard to make sure that the CoreModule will be loaded one time only in the AppModule
        if(parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/CoreModule.ts